/**
 * @file Generic copy to clipboard component.
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Clipboard extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    onCopied: PropTypes.func,
    onError: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.string,
    ]).isRequired,
    className: PropTypes.string,
  };

  copy = event => {
    event.preventDefault();
    const { text, onCopied, onError } = this.props;

    if (window.document && window.document.execCommand) {
      try {
        this.input.select();
        window.document.execCommand('copy');

        if (onCopied) {
          onCopied(text);
        }
      } catch (error) {
        if (onError) {
          onError(error);
        }
      }
    }
  };

  render() {
    const { children, text, className } = this.props;
    const classes = classNames({
      'btn-reset': true,
      [className]: !!className,
    });

    return (
      <Fragment>
        <input
          type="text"
          value={text}
          readOnly
          ref={input => {
            this.input = input;
          }}
          style={{
            height: '1px',
            overflow: 'hidden',
            position: 'fixed',
            top: '-9999em',
            left: '-9999em',
          }}
        />
        <button className={classes} onClick={this.copy}>
          {children}
        </button>
      </Fragment>
    );
  }
}

export default Clipboard;
